// Headlight templates for the PSF `Diagram` (Excalidraw) InputType. Standard + Vertical across
// Edit/Read/Print; the shared builder and the {~EditorBody:~} macro own the presentation. Tabular is
// unsupported by design (the provider throws). See EditorTemplates.js / EditorBodies.js.
const { buildEditorTemplates } = require('./EditorTemplates.js');

module.exports = buildEditorTemplates('Diagram');
